import ElementTemplate from '../ElementTemplate';
import { ContactElement } from './ContactElement';

export default class ContactModal {
  parentSection: HTMLElement;

  btn: HTMLButtonElement[];

  modalWindow: ContactElement;

  closeBtn: ElementTemplate<HTMLButtonElement>;

  isOpen: boolean = false;

  constructor(btnClass: string) {
    this.parentSection = document.body;
    this.btn = Array.from(document.querySelectorAll(btnClass) as NodeListOf<HTMLButtonElement>);
    this.modalWindow = new ContactElement();
    this.closeBtn = this.modalWindow.closeBtn;

    // Добавляем обработчики событий
    this.bindEvents();
  }

  private bindEvents(): void {
    // Проверяем наличие кнопки
    if (this.btn[0]) {
      this.btn.forEach((btn) => {
        btn.addEventListener('click', this.openModal);
      });
    }
  }

  bindOnBtn(btn: HTMLButtonElement) {
    btn.addEventListener('click', this.openModal);
  }

  clickOutsideHandler = (e: Event): void => {
    // e.preventDefault();
    e.stopPropagation();
    if (!this.modalWindow.node.lastElementChild?.contains(e.target as Element)) {
      document.removeEventListener('click', this.clickOutsideHandler);
      this.closeModal();
    }
  };

  openModal = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.isOpen) return;
    this.parentSection.append(this.modalWindow.node);
    this.isOpen = true;
    // Добавляем обработчик кнопки закрытия
    this.closeBtn.node.addEventListener('click', this.closeModal);

    // Активируем модальное окно
    this.modalWindow.node.classList.add('active');

    // Блокируем прокрутку страницы
    const scrollPos = window.scrollY;
    document.body.dataset.scrollPos = `${scrollPos}`;
    document.body.classList.add('body-no-scroll-total');
    document.body.style.top = `-${scrollPos}px`;

    // Добавляем обработчик клика вне модального окна
    document.addEventListener('click', this.clickOutsideHandler);
  };

  closeModal = () => {
    // Скрываем модальное окно
    this.modalWindow.node.classList.remove('active');

    // Восстанавливаем прокрутку, если меню не открыто
    if (!document.body.classList.contains('menu-open')) {
      document.body.classList.remove('body-no-scroll-total');
      document.body.style.removeProperty('top');

      // Восстанавливаем позицию прокрутки
      const scrollPos = Number(document.body.dataset.scrollPos || '0');
      window.scrollTo({
        top: scrollPos,
        left: 0,
        behavior: 'instant',
      });
    }

    // Удаляем обработчики событий
    this.closeBtn.node.removeEventListener('click', this.closeModal as EventListener);
    document.removeEventListener('click', this.clickOutsideHandler);
    this.isOpen = false;
    this.modalWindow.delete();
  };
}
